import React from "react";
import { useTranslation } from "react-i18next";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";

export const BasicFields = ({
    dto,
    errorInputs,
    units,
    brands,
    references,
    isEdit,
    handleInputChange,
    handleDirectInputChange,
    handleSearchProduct,
}) => {
    const { t } = useTranslation();

    const handleUnitChange = (e) => {
        const code = e.target.value;
        handleDirectInputChange("unit_code", code);
        handleDirectInputChange(
            "unit_description",
            units.find((u) => u.code === code)?.name ?? ""
        );
    };

    return (
        <>
            <Grid size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    required
                    size="small"
                    label={t("crm.products.name")}
                    name="name"
                    value={dto.name}
                    onChange={handleInputChange}
                    error={Boolean(errorInputs.name?.isError)}
                    helperText={errorInputs.name?.messageError ?? ""}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    required
                    size="small"
                    label={t("crm.products.description")}
                    name="description"
                    value={dto.description}
                    onChange={handleInputChange}
                    error={Boolean(errorInputs.description?.isError)}
                    helperText={errorInputs.description?.messageError ?? ""}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    required
                    disabled={isEdit}
                    size="small"
                    label={t("crm.products.code")}
                    name="code_sku"
                    value={dto.code_sku}
                    onChange={handleInputChange}
                    onBlur={handleSearchProduct}
                    error={Boolean(errorInputs.code_sku?.isError)}
                    helperText={errorInputs.code_sku?.messageError ?? ""}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl
                    fullWidth
                    required
                    size="small"
                    error={Boolean(errorInputs.unit_code?.isError)}
                >
                    <InputLabel>{t("crm.products.unitOfMeasurement")}</InputLabel>
                    <Select
                        label={t("crm.products.unitOfMeasurement")}
                        name="unit_code"
                        value={dto.unit_code}
                        onChange={handleUnitChange}
                    >
                        {units.map((unit) => (
                            <MenuItem key={unit.code} value={unit.code}>
                                {unit.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {errorInputs.unit_code?.isError && (
                        <FormHelperText>{errorInputs.unit_code.messageError}</FormHelperText>
                    )}
                </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth size="small">
                    <InputLabel>{t("crm.products.brand")}</InputLabel>
                    <Select
                        label={t("crm.products.brand")}
                        name="brand"
                        value={dto.brand}
                        onChange={handleInputChange}
                    >
                        {brands.map((b) => (
                            <MenuItem key={b.code} value={b.code}>{b.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth size="small">
                    <InputLabel>{t("crm.products.reference")}</InputLabel>
                    <Select
                        label={t("crm.products.reference")}
                        name="reference"
                        value={dto.reference}
                        onChange={handleInputChange}
                    >
                        {references.map((r) => (
                            <MenuItem key={r.code} value={r.code}>{r.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </>
    );
};